import React from 'react';

import { LoggedOutEmptyStateImage } from 'features/menu/pages/favorites-page/favorites-card-list/empty-state/images';
import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from 'features/menu/pages/favorites-page/favorites-card-list/empty-state/styled';

import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';

const LoggedOutEmptyState = () => {
  const { openSignInModal } = useAuthContext();

  const onPress = () => {
    openSignInModal();
  };

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <LoggedOutEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('unauthenticatedFavoritesHeader')}</HeaderText>
      <SubText>{t('unauthenticatedFavoritesSubtext')}</SubText>
      <StyledActionButtonLink onPress={onPress}>{t('logIn')}</StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default LoggedOutEmptyState;
